import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";

export default {
  name: "PaymentAttributeDetail",
  components: {
    MainLayout,
    Loading
  },

  data() {
    return {
      noDataMsg: "No Data Found",
      isLoading: false,
      paymentAttributeData: {},
    };
  },

  methods: {
    getPaymentAttributeById() {
      const id = this.$route.params.id;

      axios.get(`/paymentAttribute/detail/${id}`)
        .then((response) => {
          if (response.data !== undefined) {
            this.paymentAttributeData = response.data;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          } else {
            console.error("Error fetching payment attribute detail:", error);
          }
          this.isLoading = false;
        });
    },

    showList() {
      this.$router.push({
        path: "/paymentAttribute/list"
      });
    },
  },

  mounted() {
    this.isLoading = true;
    this.getPaymentAttributeById();
  },
};
